/* eslint-disable no-param-reassign */
const mutations = {
  /**
   * 设置二维码id
   * @param state {Vuex.State}
   * @param QRCodeID {id} 二维码id
   */
  setQRCodeID(state, QRCodeID) {
    state.QRCodeID = QRCodeID
    window.localStorage.setItem('QRCodeID', QRCodeID)
  },
  /**
   * 设置二维码类型
   * @param state {Vuex.State}
   * @param type {string} 二维码类型
   */
  setQRCodeType(state, QRCodeType) {
    state.QRCodeType = QRCodeType
    window.localStorage.setItem('QRCodeType', QRCodeType)
  },
  /**
   * 设置项目名称
   * @param state {Vuex.State}
   * @param name {string} 项目名称
   */
  setProjectName(state, name) {
    state.projectName = name
  },
  /**
   * 设置海报标题文字
   * @param state {Vuex.State}
   * @param posterTitle {string} 海报标题文字
   */
  setPosterTitle(state, posterTitle) {
    state.posterTitle = posterTitle
  },
  /**
   * 设置海报标题文字,取数组的前5项
   * @param state {Vuex.State}
   * @param posterData {object[]} 海报数据项显示内容
   */
  setPosterData(state, posterData) {
    const splitList = posterData.length > 5 ? posterData.slice(0, 5) : posterData
    state.posterData = [...splitList]
  },
  /**
   * 设置二维码标题
   * @param state {Vuex.State}
   */
  setQrcodeName(state, name) {
    state.qrcodeName = name
  },
  /**
   * 设置二维码海报文件
   * @param state
   * @param file
   */
  setQRCodeFile(state, file) {
    state.QRCodeFile = file
  },
  /**
   * 设置编辑器的状态
   * @param state
   * @parma status {string} 编辑或者新增状态
   */
  setEditorStatus(state, status) {
    state.editorStatus = status
  },
  /**
   * 设置富文本框的内容
   * @param state
   * @parma date {string} 富文本内容
   */
  setEditorHtmlData(state, data) {
    state.editorHtmlData = data
  },
  /**
   * 设置是否显示预览modal框
   * @param state
   * @parma payload {boolean} 是否显示
   */
  setShowPreviewStatus(state, payload) {
    state.isShowEditorPreview = payload
  },
  /**
   * 设置二维码图片是否需要刷新
   * @param state
   * @parma payload {boolean} 是否需要刷新
   */
  setQrcodeImageRefresh(state, payload) {
    state.qrcodeImageRefresh = payload
  },
  /**
   * 选择模板
   * @param state
   * @parma payload {name} 模板名称
   */
  setTemplate(state, name) {
    state.templateName = name
  },
}

export default mutations
